import { BoardMember } from "../types/boardMember";

export const boardMembers: BoardMember[] = [
  {
    name: "Felipe Assef",
    picture: "/assef.jpeg",
    major: "Human Biology: Health&Disease Specialist",
    year: "4th",
    position: "coPresident",
    city: "São Paulo, SP",
    linkedin: "https://www.linkedin.com/in/felipe-schultz-assef-5002b31b2/",
  },
  {
    name: "Maria Eduarda Fonseca",
    picture: "/duda.jpeg",
    major: "Global Health Specialist",
    year: "4th",
    position: "coPresident",
    city: "Montes Claros, MG",
    linkedin: "https://www.linkedin.com/in/duda-fonseca/",
  },
  {
    name: "Luísa Gerhard",
    picture: "/luisa.jpeg",
    major: "Pharmacology and Biomed Toxicology",
    year: "4th",
    position: "finance",
    city: "São Paulo, SP",
    linkedin: "https://www.linkedin.com/in/lu%C3%ADsa-naomi-gerhard-563743260/",
  },
  {
    name: "Gaio Augusto",
    picture: "/aa.jpeg",
    major: "Computer Engineering",
    year: "4th",
    position: "digitalCoordinator",
    city: "Curitiba, PR",
    linkedin: "https://www.linkedin.com/in/gaioaugusto/",
  },
  {
    name: "Laura Remy",
    picture: "/lauraRemy.jpeg",
    major: "International Relations and Psychology",
    year: "4th",
    position: "externalRelations",
    city: "São Paulo, SP",
    linkedin: "https://www.linkedin.com/in/laura-landau-remy-/",
  },
  {
    name: "Laura Ferreira",
    picture: "/laura.jpeg",
    major: "Biological Chemistry",
    year: "4th",
    position: "eventsCoordinator",
    city: "São Paulo, SP",
    linkedin: "https://www.linkedin.com/in/laura-ferreira-6a6962286/",
  },
  {
    name: "Sabrina Dodge Terra",
    picture: "/sabrinaDodge.jpeg",
    major: "Life Sciences",
    year: "2nd",
    position: "eventsCoordinator",
    city: "São Paulo, SP",
    linkedin: "https://www.linkedin.com/in/sabrina-dodge-terra-26818030b/",
  },
  {
    name: "Bruna Borer",
    picture: "/bruna.jpeg",
    major: "Psychology and Cinema Studies",
    year: "4th",
    position: "designer",
    city: "São Paulo, SP",
  },
  {
    name: "Ana Martinez",
    picture: "/socialMediaRep.jpeg",
    major: "Social Sciences",
    year: "2nd",
    position: "socialRepresentative",
    city: "Avare, SP",
    linkedin: "https://www.linkedin.com/in/ana-quintas-arthuzo-martinez/",
  },
  {
    name: "Henrique Braz",
    picture: "/alumniOutreach.jpeg",
    major: "Mechanical Engineering",
    year: "3rd",
    position: "alumniOutreach",
    city: "Curitiba, PR",
    linkedin: "https://www.linkedin.com/in/henriquebraz/",
  },
  {
    name: "João Guilherme Black",
    picture: "/firstYearRep.png",
    major: "Political Sciences",
    year: "4th",
    position: "firstYearOfficer",
    city: "Recife, PE",
    linkedin:
      "https://www.linkedin.com/in/joao-guilherme-camarotti-black-bezerra-413a76257/",
  },
  {
    name: "Datise Biasi",
    picture: "/gradRep.jpeg",
    major:
      "MEd (Master in Education) in Adult Education and Community Development",
    year: "2nd",
    position: "graduateRep",
    city: "São Paulo, SP",
    linkedin: "https://www.linkedin.com/in/datisebiasi/",
  },

  {
    name: "Giovanna Cardoso",
    picture: "/utscRep.jpeg",
    major: "Neuroscience and Psychology",
    year: "2nd",
    position: "utscRep",
    city: "Natal, RN",
    linkedin: "https://www.linkedin.com/in/giovanna-cardoso-a6a49432a/",
  },
  {
    name: "Gabrielle Mei",
    picture: "/utmRep.jpeg",
    major: "Forensic Science",
    year: "2nd",
    position: "utmRep",
    city: "São Paulo, SP",
    linkedin: "https://www.linkedin.com/in/gabrielle-mei-francisco-4a798a275/",
  },
];
